import routes from './routes'

export default routes



// WEBPACK FOOTER //
// ./src/router/dashboard/index.js